export const levelToRank = (level) => {
  switch (level) {
    case 'very_good':
      return 3;
    case 'good':
      return 2;
    case 'satisfactory':
      return 1;
    case 'needs_improvement':
    default:
      return 0;
  }
};

export const isAtLeastLevel = (level, threshold) => levelToRank(level) >= levelToRank(threshold);

const normalizeThresholds = (evaluation, thresholds) => {
  if (typeof thresholds === 'string') {
    return Object.fromEntries(Object.keys(evaluation || {}).map((dim) => [dim, thresholds]));
  }
  if (!thresholds || typeof thresholds !== 'object') {
    return null;
  }
  return thresholds;
};

// thresholdOrMap can be a single level string or a per-dimension map
export const allDimensionsMeetThresholds = (evaluation, thresholds) => {
  const normalizedThresholds = normalizeThresholds(evaluation, thresholds);
  if (!normalizedThresholds) return false;

  const requiredEntries = Object.entries(normalizedThresholds);
  if (requiredEntries.length === 0) return false;
  if (!evaluation || typeof evaluation !== 'object') return false;

  return requiredEntries.every(([dim, threshold]) => {
    const level = evaluation?.[dim]?.level;
    if (!level || !threshold) return false;
    return isAtLeastLevel(level, threshold);
  });
};
